import { Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { tap } from "rxjs/operators";


@Injectable()
export class SessionEffects {
    constructor(
        private actions$: Actions
    ) { }
}
